import project4 from "../../../Assets/dashboard-screenshot2.jpg";
import project6 from "../../../Assets/dashtrackimg.png";
import project7 from "../../../Assets/anonimg.png";
import project5 from "../../../Assets/dami.png";
import project2 from "../../../Assets/sirleaf.png";
import project3 from "../../../Assets/Screenshot 2025-06-11 103701.png";

export const ProjectsData = [
  {
    id: "1",
    title: "Pages by dami",
    img: project5,
    info: "Pages by dami design-built with Next js and Tailwind",
    stacks: [
      "Tech Stack:",
      "Next js",
      "Tailwind css",
      "Material UI",

      "Typescript",
    ],
    url: "https://pagesbydami.printivo.com/",
  },

  {
    id: "2",
    title: "Sirleaf Software agency",
    img: project2,
    info: "Sirleaf Software Agency crafted its design using React.js and Bootstrap",
    stacks: ["Tech Stack:", "Next js", "Bootstrap css", "Typescript"],
    url: "https://ssda-web.vercel.app/",
  },

  {
    id: "3",
    title: "Redivivis",
    img: project3,
    info: "Redivivis, Crafted its design using Next.js,Tailwind CSS and Typescript",
    stacks: [
      "Tech Stack:",
      "Next js",
      "Tailwind css",
      "Typescript",
      "Zustand",
      "React Query",
      "Figma",
    ],
    url: "https://startling-meerkat-271d48.netlify.app/",
  },

  {
    id: "4",
    title: "Paybox Dashboard",
    img: project4,
    info: "Paybox dashboard UI design- built with React Js and SCSS",
    stacks: ["Tech Stack:", "React Js", "SCSS", "Material UI", "Recharts"],
    url: "https://paybox-dashboard.netlify.app/",
  },
  {
    id: "5",
    title: "Penbuddy",
    img: project7,
    info: "A Blogging community where you can share your stories and thoughts without revealing your identity.",
    stacks: [
      "Typescript",
      "NextJs 14",
      "Context API",
      "Prisma[Postgresql]",
      "CSS Module",
      "react-hook-form",
      "Jose",
      "Cloudinary",
      "Bcrypt",
      "Zod",
      "Figma",
      "JWT",
    ],
    url: "https://penbuddies.vercel.app",
  },
  {
    id: "6",
    title: "Dashtrack",
    img: project6,
    info: "A performance monitoring tool that is used to diagose performance issues, and also suggests best ways to fix or prevent them.",
    stacks: ["Typescript", "React Js", "Context API", "Tailwind CSS", "Vite"],
    url: "https://dash-track.vercel.app",
  },
];
